// Customizable Area Start
Object.defineProperty(exports, "__esModule", {
  value: true,
});

exports.userName = "User name";
exports.location = "Location";
exports.url = "Location";
exports.educationList = "/profile/educational_qualifications";
exports.projectList = "/profile/projects";
exports.awardList = "/profile/awards";
exports.patentList = "/profile/publication_patents";

exports.educationalTitle = "Educational Qualification";
exports.projectLabel = "Project";
exports.awardsLabel = "Awards";
exports.publicationPatentLabel = "Publication Patents";
exports.showMore = "Show More";
exports.noProjectText = "No project...";
exports.noQualiText = "No qualifications";
exports.noAwards = "No Award...";
exports.noPublicationPatents = "No Publication Patents...";
exports.closeText = "Close";
exports.userNameLabel = "User name";
exports.urlLabel = "Url";
exports.projectDurationLabel = "Project Duration";
exports.toLabel = "to";
exports.descriptionLabel = "Description";
exports.projectNameLabel = "Project name";
exports.projectDetailsLabel = "Project Details";
exports.awardDetailsLabel = "Award Details";
exports.titleLabel = "Title";
exports.associatedWithLabel = "Associated with";
exports.issuerLabel = "Issuer";
exports.issueDateLabel = "Issue date";
exports.patentDetailsLabel = "Patent Details";
exports.patentsEmptyText = "No publication patents found";
exports.publicationsLabel = "Publications";
exports.authorLabel = "Author";
exports.noProjectsLabel = "No Projects";
exports.projectsLabel = "Projects";
exports.gradesLabel = "Grades";
exports.durationLabel = "Duration";
exports.noAwardsLabel = "No Awards";

exports.getEducationContentType = "application/json";
exports.getEducationApiMethod = "GET";
exports.getEducationApiEndPoint = "profile/educational_qualifications";

exports.getProjectContextType = "application/json";
exports.getProjectApiMethod = "GET";
exports.getProjectApiEndPoint = "profile/projects";

exports.getAwardsContextType = "application/json";
exports.getAwardsApiMethod = "GET";
exports.getAwardsApiEndPoint = "profile/awards";

exports.getPatentsContextType = "application/json";
exports.getPatentsApiMethod = "GET";
exports.getPatentsApiEndPoint = "profile/publication_patents";

exports.btnProjectsTestId = "projectsButton";
exports.btnProjectsShowMoreTestId = "btnProjectsShowMore";
exports.projectsEmptyTestId = "projectsEmpty";

exports.btnAwardsTestId = "awardsButton";
exports.btnAwardsShowMoreTestId = "btnAwardsShowMore";
exports.awardsEmptyTestId = "awardsEmpty";

exports.btnPatentsTestId = "patentsButton";
exports.btnPatentsShowMoreTestId = "btnPatentsShowMore";
exports.patentsEmptyTestId = "patentsEmpty";

exports.qualificationsListItemTestId = "qualificationsListItem";
exports.qualificationsEmptyTestId = "qualificationsEmpty";

exports.hideKeyboardTestID = "hideKeyboard";
exports.modalWindowTestId = "modalWindow";

exports.openUrlTestId = "openUrl";
// Customizable Area End
